// @flow

/* eslint-disable no-unused-vars */

import React from "react";

/**
 * Returns web element to be rendered.
 *
 * @param {string} timerValue - String to display as time.
 * @param {Object} textStyle - Unused on web.
 *
 * @returns {ReactElement}
 *
 *
 */
const storeInLocalStorage = (val) => {
    console.log("set time in localstorage", val);
    localStorage.setItem("time", val);
};
export default function renderConferenceTimer(
    timerValue: string,
    textStyle: Object
) {
    storeInLocalStorage(timerValue);

    return <span className="subject-timer">{timerValue}</span>;
}
